export default __webpack_public_path__ + "static/media/Icon material-delete.b78d30bf.svg";